export const MutationKeys = {
  assignCustomField: ['customFields', 'add'] as const,
  updateCustomFieldValue: ['customFields', 'update'] as const,
  unassignCustomField: ['customFields', 'remove'] as const,
};
